import { apiRequest } from '@/utils/api-request';

interface StopWorkflowResponse {
  success: boolean;
  message: string;
  session_id: string;
  /**
   * True when the backend discovered the workflow was already
   * terminal on Temporal and reconciled the PG row.  Caller should
   * treat this as a successful stop (no error toast) and tear down
   * the live-run UI so the user stops interacting with a dead run.
   */
  was_already_completed?: boolean;
}

export const stopWorkflow = async (
  workflowId: string,
  sessionId: string,
  orgId: string,
) => {
  const response = await apiRequest<StopWorkflowResponse>({
    url: `/workflow/${orgId}/${workflowId}/${sessionId}/stop-workflow`,
    method: 'POST',
    target: 'workflow',
    body: {},
  });

  return response as StopWorkflowResponse;
};
